import React from "react";
import { BarChart3 } from "lucide-react";

// Expanded Balance Sheet Data
const BalanceSheetInfo = [
  { metric: "Year", values: ["2022", "2023", "2024"], bold: true, isHeader: true },

  // Current Assets
  { metric: "Current Assets", values: ["", "", ""], bold: true },
  { metric: "  - Cash & Equivalents", values: ["$500,000", "$600,000", "$700,000"], bold: false },
  { metric: "  - Accounts Receivable", values: ["$300,000", "$350,000", "$400,000"], bold: false },
  { metric: "  - Inventory", values: ["$400,000", "$450,000", "$500,000"], bold: false },
  { metric: "  - Prepaid Expenses", values: ["$50,000", "$60,000", "$70,000"], bold: false },
  { metric: "Total Current Assets", values: ["$1,250,000", "$1,460,000", "$1,670,000"], bold: true },

  // Fixed Assets
  { metric: "Fixed Assets", values: ["", "", ""], bold: true },
  { metric: "  - Property, Plant & Equipment", values: ["$1,300,000", "$1,400,000", "$1,500,000"], bold: false },
  { metric: "  - Intangible Assets", values: ["$100,000", "$150,000", "$200,000"], bold: false },
  { metric: "  - Investments", values: ["$200,000", "$250,000", "$300,000"], bold: false },
  { metric: "Total Fixed Assets", values: ["$1,600,000", "$1,800,000", "$2,000,000"], bold: true },

  // Total Assets
  { metric: "Total Assets", values: ["$2,850,000", "$3,260,000", "$3,670,000"], bold: true },

  // Liabilities
  { metric: "Liabilities", values: ["", "", ""], bold: true },

  // Current Liabilities
  { metric: "  - Accounts Payable", values: ["$400,000", "$450,000", "$500,000"], bold: false },
  { metric: "  - Short-term Debt", values: ["$300,000", "$350,000", "$400,000"], bold: false },
  { metric: "  - Accrued Expenses", values: ["$150,000", "$170,000", "$190,000"], bold: false },
  { metric: "Total Current Liabilities", values: ["$850,000", "$970,000", "$1,090,000"], bold: true },

  // Long-Term Liabilities
  { metric: "  - Long-term Debt", values: ["$800,000", "$900,000", "$1,000,000"], bold: false },
  { metric: "  - Deferred Tax Liabilities", values: ["$50,000", "$60,000", "$70,000"], bold: false },
  { metric: "  - Lease Obligations", values: ["$100,000", "$120,000", "$150,000"], bold: false },
  { metric: "Total Long-term Liabilities", values: ["$950,000", "$1,080,000", "$1,220,000"], bold: true },

  // Total Liabilities
  { metric: "Total Liabilities", values: ["$1,800,000", "$2,050,000", "$2,310,000"], bold: true },

  // Equity
  { metric: "Equity", values: ["", "", ""], bold: true },
  { metric: "  - Retained Earnings", values: ["$500,000", "$600,000", "$700,000"], bold: false },
  { metric: "  - Common Stock", values: ["$500,000", "$500,000", "$500,000"], bold: false },
  { metric: "  - Additional Paid-in Capital", values: ["$0", "$0", "$0"], bold: false },
  { metric: "Total Equity", values: ["$1,000,000", "$1,100,000", "$1,200,000"], bold: true },

  // Total Liabilities & Shareholders' Equity
  { metric: "Total Liabilities & Shareholder´s Equity", values: ["$2,850,000", "$3,260,000", "$3,670,000"], bold: true }
];

// Summarized Balance Sheet Component
const SummarizedBalanceSheet = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-6">
        <BarChart3 className="h-6 w-6 text-green-600" />
        <h3 className="text-lg font-medium text-gray-900">Summarized Balance Sheet</h3>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Balance Sheet (Last 3 Years) – (Amounts in USD, thousands)
      </p>

      {/* Balance Sheet Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          {/* Table Header */}
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Metric</th>
              {BalanceSheetInfo[0].values.map((year, index) => (
                <th key={index} className="border border-gray-300 px-4 py-2 text-center font-semibold">
                  {year}
                </th>
              ))}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {BalanceSheetInfo.slice(1).map((item, index) => (
              <tr key={index} className="border-b border-gray-300">
                <td className={`border border-gray-300 px-4 py-2 ${item.bold ? "font-bold" : ""}`}>
                  {item.metric}
                </td>
                {item.values.map((value, i) => (
                  <td key={i} className="border border-gray-300 px-4 py-2 text-center">
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummarizedBalanceSheet;
